import { UitkCardAloha } from "uitk-react-cards";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";
import * as React from "react";
import { PackageCardProps } from "./typings";
import { DefaultCardContents } from "components/flexComponents/Packages/components/DefaultCardContents";

export const PackageCard = ({ packageItem, index, language, isMobile }: PackageCardProps) => (
  <UitkCardAloha className="all-t-margin-three">
    <UitkLayoutGrid columns={3}>
      <UitkLayoutGridItem colSpan={1}>
        <UitkFigure ratio={UitkFigureAspectRatioType.R21_9}>
          <UitkImage src={packageItem.hotelImageUrl} alt={packageItem.hotelName} placeholderImage={true} />
        </UitkFigure>
      </UitkLayoutGridItem>
      <DefaultCardContents packageItem={packageItem} index={index} language={language} overImage={false} grid={true} />
    </UitkLayoutGrid>
  </UitkCardAloha>
);
